import { render } from "./BottomNav.vue?vue&type=template&id=e6a09a2e&scoped=true"
const script = {}

import "./BottomNav.vue?vue&type=style&index=0&id=e6a09a2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a09a2e"]])

export default __exports__